"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrbitalLaboratories = void 0;
var Card_1 = require("../Card");
var CardType_1 = require("../CardType");
var CardName_1 = require("../../CardName");
var CardRenderer_1 = require("../render/CardRenderer");
var Resources_1 = require("../../Resources");
var Tags_1 = require("../Tags");
var OrbitalLaboratories = (function (_super) {
    __extends(OrbitalLaboratories, _super);
    function OrbitalLaboratories() {
        return _super.call(this, {
            cardType: CardType_1.CardType.AUTOMATED,
            name: CardName_1.CardName.ORBITAL_LABORATORIES,
            cost: 18,
            tags: [Tags_1.Tags.SCIENCE, Tags_1.Tags.PLANT, Tags_1.Tags.SPACE],
            metadata: {
                cardNumber: 'Pf07',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.plants(1).nbsp.production((function (pb) { return pb.plants(2); }));
                }),
                description: 'Increase your plant production by 2. Gain 1 plant.',
            },
        }) || this;
    }
    OrbitalLaboratories.prototype.play = function (player) {
        player.addResource(Resources_1.Resources.PLANTS, 1);
        player.addProduction(Resources_1.Resources.PLANTS, 2);
        return undefined;
    };
    return OrbitalLaboratories;
}(Card_1.Card));
exports.OrbitalLaboratories = OrbitalLaboratories;
